import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIncorrect = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "M12 20a7.952 7.952 0 0 1-4.897-1.688l11.209-11.21A7.955 7.955 0 0 1 20.001 12c0 4.411-3.59 8-8.001 8zm-8-8c0-4.411 3.589-8 8-8 1.846 0 3.543.635 4.897 1.688L5.688 16.898A7.952 7.952 0 0 1 3.999 12zm8-10C6.478 2 2 6.477 2 12c0 5.522 4.478 10.001 10 10.001S22 17.522 22 12c0-5.523-4.478-10-10-10z",
		clipRule: "evenodd"
	})
});
export default SvgIncorrect;
